module.exports = __webpack_public_path__ + "img/signalfel.ce2d2319.png";